import { ValidNonScheduledType } from './campaign/rulesets/channels';

export type ValidTemplateType = 'OnsiteInjected' | 'OnsiteMessage' | 'Email' | 'SMS';

export interface Template {
  id: string;
  name: string;
  type: ValidTemplateType | string;
}

export enum OnsiteTypes {
  Injected = 'OnsiteInjected',
  Message = 'OnsiteMessage',
}

export enum OffsiteTypes {
  Email = 'Email',
}

const templateTypeToChannelTypeMap: { [x in ValidTemplateType]: ValidNonScheduledType } = {
  OnsiteInjected: '.RTMInjectedChannel',
  OnsiteMessage: '.RTMOverlayChannel',
  Email: '.Email',
  SMS: '.SMS',
};

export function getChannelType(templateType: ValidTemplateType): ValidNonScheduledType {
  return templateTypeToChannelTypeMap[templateType];
}
